import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 18,
	viewBox: "0 0 16 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.7293 7.95842C14.1525 7.95842 14.5106 8.12118 14.8361 8.41414C15.1291 8.73967 15.2918 9.09774 15.2918 9.52092V15.7709C15.2918 16.2266 15.1291 16.5847 14.8361 16.8777C14.5106 17.2032 14.1525 17.3334 13.7293 17.3334H2.271C1.81527 17.3334 1.45719 17.2032 1.16423 16.8777C0.838704 16.5847 0.708496 16.2266 0.708496 15.7709V9.52092C0.708496 9.09774 0.838704 8.73967 1.16423 8.41414C1.45719 8.12118 1.81527 7.95842 2.271 7.95842H3.05225V5.61467C3.05225 4.73576 3.24756 3.92196 3.70329 3.14071C4.15902 2.39201 4.74495 1.80607 5.5262 1.35034C6.2749 0.894613 7.0887 0.666748 8.00016 0.666748C8.87907 0.666748 9.69287 0.894613 10.4741 1.35034C11.2228 1.80607 11.8088 2.39201 12.2645 3.14071C12.7202 3.92196 12.9481 4.73576 12.9481 5.61467V7.95842H13.7293ZM10.3439 7.95842V5.61467C10.3439 4.96362 10.116 4.41024 9.66032 3.95451C9.20459 3.49878 8.6512 3.27091 8.00016 3.27091C7.34912 3.27091 6.79573 3.49878 6.34001 3.95451C5.88428 4.41024 5.65641 4.96362 5.65641 5.61467V7.95842H10.3439Z",
		fill: "currentColor"
	})
});
export default SvgLockSolid;
